import { createClient } from "@supabase/supabase-js";

// Session-less anon client for public pages: RPC-only access, never sends a user token.
export const publicSupabase = createClient(process.env.REACT_APP_SUPABASE_URL, process.env.REACT_APP_SUPABASE_ANON_KEY, {
  auth: { persistSession: false, autoRefreshToken: false, detectSessionInUrl: false, storageKey: "mw-public" },
});
